import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import CustomButton from "../custom-material/button/Button";
import CustomDialog from "../custom-material/dialog/Dialog";
import IconButton from "@material-ui/core/IconButton";
import PropTypes from "prop-types";
import React from "react";
import { getBlob } from "../../libs/api";
import { saveAs } from "file-saver";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  dialogPaper: {
    width: 1170,
    maxWidth: 1170,
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    padding: 20,
  },
  learnMoreImage: {
    width: "100%",
    height: "100%",
  },
  actionContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    paddingTop: 20,
    borderTop: "1px solid #E5E5E5",
  },
  downloadButton: {
    width: "auto",
    minWidth: 265,
    height: 45,
    fontSize: 16,
    fontWeight: 600,
  },
  demoButton: {
    width: "auto",
    minWidth: 150,
    marginLeft: 5,
    height: 45,
    fontSize: 16,
    fontWeight: 600,
  },
  okButton: {
    width: "auto",
    minWidth: 150,
    marginLeft: 5,
    height: 45,
    fontSize: 16,
    fontWeight: 600,
  },
  arrowButton: {
    padding: 0,
  },
  arrowIcon: {
    fontSize: 64,
  },
});

class PagedDialogComponent extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      page: 0,
    };

    this.nextPage = () =>
      this.setState((prevState) => ({ page: prevState.page + 1 }));
    this.prevPage = () =>
      this.setState((prevState) => ({ page: prevState.page - 1 }));

    this.downloadBrochure = (brochurePath) => async (event) => {
      const { origin } = this.props;
      const eBrochurePath = brochurePath
        .split("/")
        .map((x) => encodeURIComponent(x))
        .join("/");
      try {
        const fileBlob = await getBlob(
          `${origin || ""}/learn-more-images/${eBrochurePath}`
        );
        saveAs(fileBlob, brochurePath.split("/").pop());
      } catch (error) {
        console.error(error);
      }
    };

    this.sendEmail = () => {
      const { emailTo, emailSubject, emailBody, contact } = this.props;

      const join = (arr, sep = "\n") => arr.filter((x) => x).join(sep) || "";
      const emailBodyContact = contact
        ? join([
            join([contact.firstName, contact.lastName], " "),
            contact.company,
            contact.officePhone,
            contact.emailAddress,
          ])
        : "";
      const body = join([emailBody, emailBodyContact]);
      window.location.href = `mailto:${
        emailTo || "healthcare@ipdanalytics.com"
      }?subject=${encodeURIComponent(
        emailSubject || "Contact me"
      )}&body=${encodeURIComponent(body || "Please contact me")}`;
    };
  }

  render() {
    const { page } = this.state;
    // use origin so this will work when used as a webcomponent somewhere else
    const {
      classes,
      dialogOpen,
      handleCloseDialog,
      items,
      brochurePath,
      podcasts,
      emailButtonText,
      children,
    } = this.props;

    const getBrochure = (brochurePath, page) => {
      if (Array.isArray(brochurePath)) {
        const brochureCurrentPageValue = brochurePath[page];
        // value is not defined in the array
        if (typeof brochureCurrentPageValue === "undefined") {
          return brochurePath[brochurePath.length - 1];
        }
        // value is defined as an object or a string
        if (brochureCurrentPageValue) {
          return brochureCurrentPageValue;
        }
        // value is defined as null
        return null;
      }
      return brochurePath;
    };

    const thisImage = Array.isArray(items)
      ? items[page]
      : typeof items === "string"
      ? `${items}/image${page}.png`
      : items;

    const thisBrochure = getBrochure(brochurePath, page);
    const thisBrochureButtonText = thisBrochure
      ? typeof thisBrochure === "string"
        ? "Download the brochure!"
        : thisBrochure.text ||
          `Download the ${thisBrochure.name || ""} brochure!`
      : null;
    const thisBrochurePath = thisBrochure
      ? typeof thisBrochure === "string"
        ? thisBrochure
        : thisBrochure.path
      : null;

    const thisPodcast = !Array.isArray(podcasts)
      ? null
      : podcasts[page]
      ? podcasts[page]
      : null;
    const thisPodcastText = !thisPodcast
      ? null
      : thisPodcast.name
      ? `Listen to our ${thisPodcast.name} podcast!`
      : "Listen to our podcast!";

    const thisEmailButtonText = emailButtonText || `Set up a demo!`;

    const numPages = Array.isArray(items) ? items.length : 1;

    return (
      <CustomDialog
        classes={{ paper: classes.dialogPaper }}
        open={dialogOpen}
        onClose={handleCloseDialog}
        disablePortal
        aria-labelledby="updates-dialog-title"
      >
        <div className={classes.contentContainer}>
          {typeof children === "function"
            ? children(thisImage, classes)
            : children}
          <div className={classes.actionContainer}>
            {[
              page > 0 ? (
                <IconButton
                  className={classes.arrowButton}
                  key={"back"}
                  onClick={this.prevPage}
                  color="secondary"
                >
                  <ArrowLeftIcon className={classes.arrowIcon} />
                </IconButton>
              ) : null,
              thisPodcast ? (
                <CustomButton
                  key={"podcast"}
                  onClick={() => window.open(thisPodcast.path)}
                  className={classes.downloadButton}
                  variant="contained"
                  size="small"
                  color="secondary"
                >
                  {thisPodcastText}
                </CustomButton>
              ) : null,
              thisBrochure ? (
                <CustomButton
                  key={"download"}
                  onClick={this.downloadBrochure(thisBrochurePath)}
                  className={classes.downloadButton}
                  variant="contained"
                  size="small"
                  color="secondary"
                >
                  {thisBrochureButtonText}
                </CustomButton>
              ) : null,
              <CustomButton
                key={"demo"}
                onClick={this.sendEmail}
                className={classes.demoButton}
                variant="contained"
                size="small"
                color="secondary"
              >
                {thisEmailButtonText}
              </CustomButton>,
              page + 1 >= (numPages || 0) ? (
                <CustomButton
                  key={"ok"}
                  onClick={handleCloseDialog}
                  className={[classes.okButton, "close"].join(" ")}
                  variant="contained"
                  size="small"
                  color="secondary"
                >
                  {"Ok, I got it!"}
                </CustomButton>
              ) : (
                <IconButton
                  className={classes.arrowButton}
                  key={"forward"}
                  onClick={this.nextPage}
                  color="secondary"
                >
                  <ArrowRightIcon className={classes.arrowIcon} />
                </IconButton>
              ),
            ]}
          </div>
        </div>
      </CustomDialog>
    );
  }
}

const brochureType = PropTypes.shape({
  path: PropTypes.string.isRequired,
  name: PropTypes.string,
  text: PropTypes.string,
});
const podcastType = PropTypes.shape({
  path: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
});
PagedDialogComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  dialogOpen: PropTypes.bool,
  handleCloseDialog: PropTypes.func.isRequired,
  items: PropTypes.oneOfType([PropTypes.any, PropTypes.arrayOf(PropTypes.any)])
    .isRequired,
  brochurePath: PropTypes.oneOfType([
    PropTypes.string,
    brochureType,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, brochureType])),
  ]),
  podcasts: PropTypes.arrayOf(podcastType),
  emailButtonText: PropTypes.string,
  emailTo: PropTypes.string,
  emailSubject: PropTypes.string,
  emailBody: PropTypes.string,
  contact: PropTypes.object,
  children: PropTypes.func,
};

export default withStyles(styles)(PagedDialogComponent);
